import { render, staticRenderFns } from "./PurpleCard2.vue?vue&type=template&id=2c63b55c&scoped=true"
import script from "./PurpleCard2.vue?vue&type=script&lang=js"
export * from "./PurpleCard2.vue?vue&type=script&lang=js"
import style0 from "./PurpleCard2.vue?vue&type=style&index=0&id=2c63b55c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c63b55c",
  null
  
)

export default component.exports